module.exports = __webpack_public_path__ + "img/38.e78fc385.jpg";